import {useDispatch, useSelector} from "react-redux";
import {condition} from "../../../res/rest/restRequest";
import {getActiveDeliveries, getShipments} from "../../../redux/action/accountActions";
import {useState} from "react";

const useShipments = () => {

    const dispatch = useDispatch();

    const { session } = useSelector(
        state => state.auth
    )
    const { loading, error, ordering, activeShipments } = useSelector(
        state => state.account
    )
    const [ fetchedDates, setFetchedDates ] = useState();

    if(!activeShipments && !loading.activeShipments && !error.activeShipments) {
        dispatch(getActiveDeliveries({session, includeProducts: true}))
    }

    const getShipmentsByDate = (startDate, endDate, limit) => {
        const conditions = [
            condition.neq("DocStatus","'IP'"),
            condition.greaterThan("created", startDate),
            condition.lessOrEqual("created", endDate)
        ]
        setFetchedDates({
            startDate, endDate
        })
        dispatch(getShipments({session, conditions, limit}));
    }

    const getActiveShipments = () => {
        dispatch(getActiveDeliveries({session, includeProducts: true}))
    }

    const getAShipment = (id) => {
        const conditions = [condition.eq("m_inOut_ID", id)]
        dispatch(getShipments({session, includeProducts: true, conditions}));
    }

    const getShipmentLines = (id) => {
        const conditions = [condition.eq("m_inOut_ID", id)]
        dispatch(getShipments({session, includeProducts: true, conditions}));
    }

    return {
        activeShipments,
        ordering,
        fetchedDates,
        loading,
        error,
        getShipmentsByDate,
        getActiveShipments,
        getAShipment,
        getShipmentLines
    }
}

export default useShipments;
